<template>
    <select name="companyBadge" id="CompanyBadge" v-model="localCompanyBadge" :disabled="!companyBadges.length">
        <option v-for="b in companyBadges" :value="b._id">
            {{ b[currentLocale] }}
        </option>
    </select>
</template>
<script setup lang="ts">
import { onMounted, ref, computed, watch } from "vue";
import {useUserStore} from "../../stores/userStore";
import {storeToRefs} from "pinia";
import {isUserRole} from "../../composables/utils";
import {UserRole} from "../../types/userRole";
import {useAuthFetch} from "../../composables/useAuthFetch";
import {ResponseStatus} from "../../types/responseStatus";
import {useStore} from "../../stores/store";

const {locale} = useI18n()
const currentLocale = locale.value

const store = useUserStore();
const { companyBadge, companyBadges} = storeToRefs(store);
const { fetchCompanyTitles } = store;
const localCompanyBadge = ref(companyBadge.value);

watch(localCompanyBadge, (badgeId) => {
    const badge = companyBadges.value.find((b) => b._id === badgeId);
    if (badge) {
        companyBadge.value = badge;
    }
});

watch(companyBadge, (newVal) => {
    localCompanyBadge.value = newVal?._id || null;
});

onMounted(async () => {
    if (!isUserRole.value([UserRole.MANAGER])) return;

    await fetchCompanyTitles();

    if (!companyBadge.value && companyBadges.value.length) {
        companyBadge.value = companyBadges.value[0];
    }

    localCompanyBadge.value = companyBadge.value?._id || null;
});
</script>